/**
 * ROC 7
 * Copyright 2017 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */

define('modules/Upcharges/Impl/GiftWrapUpcharge',[
    'jquery',
    'lodash',
    'global/all',
    'modules/Upcharges/UpchargeRegistrationService'
], function ($, _, Roc, UpchargeRegistrationService) {
    'use strict';


    var upchargeCode = 'GIFTWRAP';    

    var selectors = {
        checkboxSelector: 'input[data-roc-field="isGiftWrap"]',        
        giftWrapForm: '[data-roc-wrapper="gift-wrap-form"]'
    }

    function preRenderQuickView(viewModel) {
        var giftWrapConfiguration = {
            isGiftWrapEnable: false,
            showGiftWrapForm: false
        };

        var upchargesSettings = window.RocConfig.upcharges.configuration;
        var gWrapConfiguration = _.find(upchargesSettings, function (upchargeSettings) {
            return upchargeSettings.upchargeCode == upchargeCode;
        });

        if (gWrapConfiguration && gWrapConfiguration.configuration["isGiftWrapEnabled"]) {
            giftWrapConfiguration.isGiftWrapEnable = gWrapConfiguration.configuration["isGiftWrapEnabled"];
        }

        var isGiftWrappable = false;
        var isGiftWrappableAttrs = viewModel.product.customFields["isGiftWrappable"];

        if (viewModel.product.productType === 'Simple' && isGiftWrappableAttrs && _.some(isGiftWrappableAttrs)) {
            isGiftWrappable = _.some(isGiftWrappableAttrs, function (attr) { return attr.value; })
        }
        giftWrapConfiguration.showGiftWrapForm = gWrapConfiguration && isGiftWrappable && viewModel.product.canAddProduct && viewModel.product.productType !== 'Group';

        viewModel.giftWrapConfiguration = giftWrapConfiguration;
    }

    function bindEvents() {     
        Roc.EventManager.bind(Roc.Events.products.SELECTIONS_UPDATE, reloadProductGiftWrap);
    }

    function reloadProductGiftWrap(viewModel) {
        var isGiftWrappable = false;
        var isGiftWrappableAttrs = viewModel.customFields["isGiftWrappable"];

        if (viewModel.productType === 'Simple' && isGiftWrappableAttrs && _.some(isGiftWrappableAttrs)) {
            isGiftWrappable = _.some(isGiftWrappableAttrs, function (attr) { return attr.value; })
        }

        // reset gift wrap form
        $(selectors.giftWrapForm).toggle(isGiftWrappable);
        $(selectors.checkboxSelector).prop('checked', false);
    }

    function populateUpchargeData(upchargeData) {
        var giftWrappingInput = $(selectors.checkboxSelector + ":checked");

        if (giftWrappingInput.length > 0) {
            upchargeData[upchargeCode] = {
                'code': upchargeCode
            };
        }
    }


    var GiftWrapUpcharge = {
        preRenderQuickView: preRenderQuickView,
        populateUpchargeData: populateUpchargeData,
        bindEvents: bindEvents
    };

    Roc.Logger.debug('GiftWrapUpcharge.js Loaded:', GiftWrapUpcharge);

    // register upcharge
    UpchargeRegistrationService.register(upchargeCode, GiftWrapUpcharge);

    return GiftWrapUpcharge;
});

